import React, {useMemo, useState} from "react";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {DataGrid, ruRU} from "@material-ui/data-grid";

import {FillerSection} from "../../FillerSection/FillerSection";
import {DeleteButtonTextField} from "../../DeleteButtonTextField/DeleteButtonTextField";
import {getNumericId} from "../../../utils/uniqueIds";


export const BaseSelectFiller = ({setFieldValue, content}) => {
    const choices = useMemo(() => {
        if (content?.choices && content?.choices?.length > 0) {
            return content?.choices
        }
        return []
    }, [content.choices])
    const [columns, setColumns] = useState(() => {
            const payload = choices.find(f => f?.payload || f?.payload !== null)?.payload
            if (payload) {
                const payloadColumns = Object.entries(choices[0].payload).map(([key]) => ({
                    field: key,
                    headerName: key,
                    editable: true,
                    disabled: false,
                    width: 350,
                }))
                return [{
                    field: 'value',
                    headerName: 'value',
                    editable: true,
                    disabled: true,
                    width: 350,
                }, ...payloadColumns]
            }
            return [{
                field: 'value',
                headerName: 'value',
                editable: true,
                disabled: true,
                width: 350,
            }]

        }
    )
    const rows = useMemo(() => choices?.map(el =>
            ({id: el?.id ? el?.id : getNumericId(), value: el.value, ...el.payload})),
        [choices])

    const [selectionModel, setSelectionModel] = useState([])

    const handleColumnAdd = () => {
        setColumns(prev => [...prev, {field: '', headerName: '', disabled: false, editable: true, width: 350,}])
    }

    const handleColumnChange = index => event => {
        setColumns(prev => prev.map((column, i) => {
            if (i === index) {
                return ({...column, field: event.target.value, headerName: event.target.value, width: 350})
            }
            return column
        }))
    }

    const handleColumnDelete = (index, field) => () => {
        setColumns(prev => prev.filter((_, i) => index !== i))
        setFieldValue('content.choices', choices.map(el => ({
                ...el, payload:
                    Object.fromEntries(
                        Object.entries(el.payload).filter(([key]) => key !== field))
            })
            )
        )
    }

    const handleRowAdd = () => {
        setFieldValue('content.choices', [...choices, {id: getNumericId(), value: '', payload: {}}])
    }

    const handleRowChange = (params) => {
        setFieldValue('content.choices', choices.map(row => {
            if (row.id === params.id) {
                if (params.field === 'value') {
                    return {...row, [params.field]: params.value}
                } else {
                    return {
                        ...row, payload: {
                            ...row.payload,
                            [params.field]: params.value
                        }
                    }
                }
            }
            return row
        }))
    }

    const handleRowDelete = () => {
        setFieldValue('content.choices', choices.filter(f => !selectionModel.includes(f.id)))
    }

    return <>
        <FillerSection title={'Столбцы'} onAddButtonClick={handleColumnAdd}>
            <Grid item container spacing={2}>
                {columns.map((column, index) =>
                    <Grid key={`base-select-${index}`} xs={2} item>
                        <TextField onChange={handleColumnChange(index)}
                                   value={column.field}
                                   variant={'outlined'}
                                   disabled={column.disabled}
                                   size={"small"}
                                   fullWidth
                        />
                        <DeleteButtonTextField onClick={handleColumnDelete(index, column.field)}
                                               hidden={column.disabled}
                        />
                    </Grid>
                )}
            </Grid>
        </FillerSection>
        <FillerSection title={'Данные'}
                       onAddButtonClick={handleRowAdd}
                       onDeleteButtonClick={handleRowDelete}
                        disabledDeleteButton={selectionModel.length === 0}
        >
            <DataGrid rows={rows}
                      columns={columns}
                      density={'compact'}
                      localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                      onCellEditCommit={handleRowChange}
                      onSelectionModelChange={(newSelectionModel) => {
                          setSelectionModel(newSelectionModel);
                      }}
                      selectionModel={selectionModel}
                      disableColumnMenu
                      style={{height: '250px'}}
            />
        </FillerSection>
    </>
}